import Gene, { StatusTypes } from './Gene';
import { GeneInfo, GeneType, GeneTypes } from './types';

const makeInfo = (
  qualifier: string,
  percent: number,
  type: GeneType
): GeneInfo => ({
  prefix: `lac`,
  label: `Lac${qualifier}`,
  percent,
  qualifier,
  type,
});

const makeState = (status: StatusTypes, superscript: string) => ({
  status,
  superscript,
});

const makeLacI = () => {
  return new Gene(makeInfo('I', 0.169, GeneTypes.LacI), [
    makeState(StatusTypes.Inducible, '+'),
    makeState(StatusTypes.NonInducible, 's'),
    makeState(StatusTypes.Constitutive, '-'),
  ]);
};

const makeLacP = () => {
  return new Gene(makeInfo('P', 0.036, GeneTypes.LacP), [
    makeState(StatusTypes.Inducible, '+'),
  ]);
};

const makeLacO = () => {
  return new Gene(makeInfo('O', 0.012, GeneTypes.LacO), [
    makeState(StatusTypes.Inducible, '+'),
    makeState(StatusTypes.Constitutive, 'c'),
  ]);
};

const makeLacZ = () => {
  return new Gene(makeInfo('Z', 0.547, GeneTypes.LacZ), [
    makeState(StatusTypes.Inducible, '+'),
    makeState(StatusTypes.NonInducible, '-'),
  ]);
};

const makeLacY = () => {
  return new Gene(makeInfo('Y', 0.111, GeneTypes.LacY), [
    makeState(StatusTypes.Inducible, '+'),
    makeState(StatusTypes.NonInducible, '-'),
  ]);
};

const makeLacA = () => {
  return new Gene(makeInfo('A', 0.115, GeneTypes.LacA), [
    makeState(StatusTypes.Inducible, '+'),
    makeState(StatusTypes.NonInducible, '-'),
  ]);
};

export default class GeneFactory {
  static make(type: GeneType): Gene {
    switch (type) {
      case GeneTypes.LacI:
        return makeLacI();
      case GeneTypes.LacP:
        return makeLacP();
      case GeneTypes.LacO:
        return makeLacO();
      case GeneTypes.LacZ:
        return makeLacZ();
      case GeneTypes.LacY:
        return makeLacY();
      case GeneTypes.LacA:
        return makeLacA();

      default:
        break;
    }

    throw new Error('Invalid GeneType in GeneFactory');
  }
}
